import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

interface ExpandableDataGridProps {
  children: React.ReactNode;
  title?: string;
}

const ExpandableDataGrid: React.FC<ExpandableDataGridProps> = ({ children, title }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [isExpanded, setIsExpanded] = React.useState(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box 
        onClick={handleToggle}
        sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          mb: 2,
          mt: 2,
          p: 2,
          backgroundColor: theme.palette.background.paper,
          borderRadius: (isMobile ? 0 : 1),
          border: `1px solid ${theme.palette.mode === 'dark' ? 'grey.700' : 'grey.300'}`,
          cursor: 'pointer',
          transition: 'background-color 0.2s ease-in-out'
        }}>
        <Typography variant="h4" sx={{ fontWeight: 500 }}>
          {title || 'Data Details'}
        </Typography>
        <Button
          variant="outlined"
          size="small"
          endIcon={isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          sx={{
            minWidth: 'auto',
            height: '36px',
            p: '6px 12px',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center'
          }}
          onClick={handleToggle}
        >
          {isExpanded ? (isMobile ? 'Hide' : 'Hide details') : (isMobile ? 'Details' : 'See details')}
        </Button>
      </Box>
      
      {isExpanded && (
        <Box sx={{ mb: 2 }}>
          {children}
        </Box>
      )}
    </Box>
  );
};

export default ExpandableDataGrid;
